const routes = [
  {
    path: '/stock/products/:page?',
    props: true,
    component: () => import('@/views/stock/product/ProductsStock.vue')
  },
  {
    path: '/stock/locations/:page?',
    props: true,
    component: () => import('@/views/stock/location/LocationsStock.vue')
  },
  {
    path: '/stock/states/:page?',
    props: true,
    component: () => import('@/views/stock/state/StatesStock.vue')
  },

  {
    path: '/stock/expirations/:searchType?/:page?',
    props: true,
    component: () => import('@/views/stock/expiration/Expirations.vue')
  },

  {
    path: '/stock/product/:productId/:startDate?/:endDate?',
    props: true,
    component: () => import('@/views/stock/product/ProductStock.vue')
  },
  {
    path: '/stock/batches/:page?',
    props: true,
    component: () => import('@/views/stock/batch/Batches.vue')
  },
  {
    path: '/stock/batch/:batchId/:nav?/:page?',
    props: true,
    component: () => import('@/views/stock/batch/Batch.vue')
  },
  {
    path: '/stock/checkpoints/:page?',
    props: true,
    component: () => import('@/views/stock/checkpoint/Checkpoints.vue')
  },
  {
    path: '/stock/checkpoint/:checkpointId/:nav?/:page?',
    props: true,
    component: () => import('@/views/stock/checkpoint/Checkpoint.vue')
  },
  {
    path: '/stock/register/variations/positive',
    props: true,
    component: () => import('@/views/stock/variation/PositiveVariationRegister.vue')
  },
  {
    path: '/stock/register/variations/negative',
    props: true,
    component: () => import('@/views/stock/variation/NegativeVariationRegister.vue')
  },
  {
    path: '/stock/variations/:startDate?/:endDate?',
    props: true,
    component: () => import('@/views/stock/variation/Variations.vue')
  },
]

export default routes
